import ModernDrawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import { Button, Row, Typography, styled, Column } from 'shared/Houston';
import { enOrderBumpStatus } from 'types/enums';

import { css } from '@eduzz/houston-styles/styled';

interface IDrawerProps {
  open: boolean;
  onClose?: () => void;
  direction: 'left' | 'right' | 'top' | 'bottom';
  children?: React.ReactNode;
  duration?: number;
  overlayOpacity?: number;
  overlayColor?: string;
  enableOverlay?: boolean;
  style?: React.CSSProperties;
  zIndex?: number;
  size?: number | string;
  className?: string | undefined;
  height: string;
}

export const Drawer = styled(ModernDrawer)<IDrawerProps>`
  top: 35px !important;
  padding: ${({ theme }) => theme.spacing.xxxs};
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.neutralColor.high.medium};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutralColor.high.dark};
    border-radius: ${({ theme }) => theme.border.radius.sm};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.neutralColor.low.light};
  }

  ${({ theme, height }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      & {
        width: 100% !important;
        padding-bottom: ${theme.spacing.xxl};
        height: ${height} !important;
      }
    }
  `}
`;

export const CloseButton = styled(Button)`
  && {
    color: ${({ theme }) => theme.neutralColor.low.medium};
  }
`;

export const Loading = styled(Row)`
  height: calc(100vh - 112px);
`;

export const RowSwitch = styled(Row)`
  width: 100%;
  margin-left: 0;
`;

export const DrawerHeaderRow = styled(Row)`
  margin: ${({ theme }) => `0 0 ${theme.spacing.xxxs}`};
`;

export const DrawerHeaderColumn = styled(Column)`
  && {
    padding: 0;
  }
`;

export const LabelSwitch = styled(Typography)`
  margin-left: ${({ theme }) => theme.spacing.nano};
  color: ${({ className, theme }) => {
    if (className !== enOrderBumpStatus.ACTIVE && className !== enOrderBumpStatus.INACTIVE) {
      return theme.neutralColor.high.dark;
    }

    return theme.neutralColor.low.dark;
  }};
`;

export const ErrorMessage = styled(Typography)<{ statusColor?: string }>`
  margin-left: ${({ theme }) => theme.spacing.xxxs};
  color: ${({ theme }) => theme.feedbackColor.warning.dark};

  &.error {
    color: ${({ theme }) => theme.feedbackColor.negative.dark};
  }
`;
